import { render, staticRenderFns } from "./ModattaCompaniesLandingOffersType.vue?vue&type=template&id=0e1a4bf9"
import script from "./ModattaCompaniesLandingOffersType.vue?vue&type=script&lang=js"
export * from "./ModattaCompaniesLandingOffersType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports